<template>
  <div
    ref="containerRef"
    v-if="items.length"
    class="max-h-[180px] flex flex-col rounded-md bg-primary border border-secondary overflow-y-auto"
  >
    <div
      class="flex items-center gap-x-2 pr-2.5 pl-2 py-2.5 hover:bg-primary_hover cursor-pointer"
      v-for="(user, index) in items"
      :class="{
        'bg-primary_hover': index === selectedIndex,
      }"
      :key="user.id"
      @click="selectItem(index)"
    >
      <Avatar
        :src="user.avatar_url"
        :name="user.fullname"
        :initials="user.avatar_initials"
      />
      <span class="truncate font-medium text-primary grow">
        {{ user.fullname }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { Avatar } from "@/SharedComponents/Avatars";
const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  command: {
    type: Function,
    required: true,
  },
});

const selectedIndex = ref(0);
const containerRef = ref(null);

const onKeyDown = ({ event }) => {
  if (event.key === "ArrowUp") {
    upHandler();
    return true;
  }

  if (event.key === "ArrowDown") {
    downHandler();
    return true;
  }

  if (event.key === "Enter") {
    enterHandler();
    return true;
  }

  return false;
};

const upHandler = () => {
  selectedIndex.value =
    (selectedIndex.value + props.items.length - 1) % props.items.length;
};

const downHandler = () => {
  selectedIndex.value = (selectedIndex.value + 1) % props.items.length;
};

const enterHandler = () => {
  selectItem(selectedIndex.value);
};

const selectItem = (index) => {
  const user = props.items[index];
  if (user) {
    props.command({ id: user.id, label: user.fullname });
  }
};

watch(
  () => selectedIndex.value,
  (value) => {
    containerRef.value.scrollTop = Math.floor(value - 1 / 4) * 44;
  }
);

watch(props.items, () => {
  selectedIndex.value = 0;
});

defineExpose({
  onKeyDown,
});
</script>
